<template>
  <z-form class="z-card" tag="div">
    <h4>{{ $t('pbx.sip-account.form.title.edit.main') }}</h4>

    <div class="z-card__body">
      <z-form-group :reset_margin="true">
        <div class="row align-items-center">
          <label class="col-3 text-right">
            {{ $t('pbx.sip-account.form.field.name') }}
          </label>

          <div class="col-9">
            <z-form-input :rules="{ required: true, latin_num: true }" vid="name">
              <i-input v-model="form.name" :clearable="true" />
            </z-form-input>
          </div>
        </div>
      </z-form-group>

      <z-form-group class="mt-1" :reset_margin="true">
        <div class="row align-items-center">
          <label class="col-3 text-right pbx-login-label">
            {{ $t('pbx.sip-account.form.field.login') }}
          </label>

          <div class="col-9">
            <z-form-input
              vid="login"
              :errors_absolute="false"
            >
              <i-input :clearable="true" disabled readonly />
              <small class="text-muted">{{ $t('pbx.sip-account.form.tooltips.login') }}</small>
            </z-form-input>
          </div>
        </div>
      </z-form-group>

      <z-form-group class="mt-1">
        <div class="row align-items-center">
          <label class="col-3 text-right">
            {{ $t('pbx.sip-account.form.field.password') }}
          </label>

          <div class="col-9">
            <z-form-input vid="password">
              <i-input :clearable="true" disabled readonly />
              <small class="text-muted">{{ $t('pbx.sip-account.form.tooltips.password') }}</small>
            </z-form-input>
          </div>
        </div>
      </z-form-group>

      <z-form-group>
        <div class="row align-items-center">
          <label class="col-3 text-right">
            {{ $t('pbx.sip-account.form.field.wrtc') }}
          </label>

          <div class="col-9">
            <z-form-input>
              <z-switch v-model="form.wrtc" />
            </z-form-input>
          </div>
        </div>
      </z-form-group>
    </div>
  </z-form>
</template>

<script>
  import isEqual from 'lodash-es/isEqual';

  export default {
    props: {
      value: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        form: {}
      };
    },

    watch: {
      value: {
        handler: function(value) {
          const { name = '',  wrtc = false } = value || {};
          this.form = { name, wrtc };
        },
        immediate: true,
        deep: true
      },

      form: {
        handler: function(form) {
          if (!isEqual(form, this.value)) {
            this.$emit('input', form);
          }
        },
        immediate: true,
        deep: true
      }
    }
  };
</script>

<style lang="scss">
  .pbx-name-label,
  .pbx-login-label {
    align-self: flex-start;
    top: 6px;
  }
</style>
